import React from "react"
import * as queryString from "query-string";
import SEO from "../components/seo";
import LayoutForm from "../components/Form/layoutForm";

const BucketListPage = ({location}) => {
  return (
    <LayoutForm
      pageDetail={{
        type:"BucketList",
        contentIndex:1,
        searchBar:true,
        gridName:"GridBox",
        cardClass:"CardBox",
        imageClass:"ImageBox",
        buttonClass:"Box",
        buttonType:"WithBackButton",
        buttonNext:"/reason-to-travel",
        buttonBack:"/travelled-places",
        before: 17,
        completed:33,
        urlParam: queryString.parse(location.search),
      }}
    >
      <SEO title="Bucket List | My Travels" />
    </LayoutForm>
  )
}

export default BucketListPage
